import { useEffect } from 'react'

export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    // Prevent double initialization
    if ((window as any).fbq) return

    // Defer pixel loading to not block initial render (improves LCP/FCP)
    const initPixel = () => {
      const f = window as any
      const n = (f.fbq = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args)
        } else {
          n.queue.push(args)
        }
      })

      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = [] as any[]

      // Load the Facebook Pixel script
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const firstScript = document.getElementsByTagName('script')[0]
      firstScript?.parentNode?.insertBefore(script, firstScript)

      // Initialize and track PageView
      f.fbq('init', pixelId)
      f.fbq('track', 'PageView')

      // Add noscript fallback
      const noscript = document.createElement('noscript')
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
      noscript.appendChild(img)
      document.body.appendChild(noscript)
    }

    // Use requestIdleCallback to defer pixel loading after main content renders
    if ('requestIdleCallback' in window) {
      ;(window as any).requestIdleCallback(initPixel, { timeout: 3000 })
    } else {
      setTimeout(initPixel, 2000)
    }
  }, [pixelId])
}
